import styled, { css } from 'styled-components'
import { ifProp, prop } from 'styled-tools'
import Button from '../../components/Button'
import colorsOptions from '../../components/stories/fundamentals/colors-styles/constants'
import {
  textStyleSizeOptions,
  textStyleWeightOptions,
  textStyleSizeStyleOptions,
  textStyleWeightStyleOptions
} from '../../components/stories/fundamentals/text-styles/constants'

export const MapWrapper = styled.div`
  @media (max-width: 767px) {
    margin-top: ${ifProp('nomargin', 0, '50px')};
  }

  .leaflet-container {
    height: ${prop('height')}px;

    .leaflet-tile-container {
      ${({ gray, bright }) => {
        if (gray) {
          return 'filter: grayscale(1);'
        }
        if (bright) {
          return 'filter: brightness(80%);'
        }
        return ''
      }}
    }
  }
`

export const Zoombutton = styled(Button)`
  display: inline-block;
  color: ${colorsOptions.greys['grey-60']};
  text-align: center;
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]};
  border-radius: 40px;
  box-shadow: 0 1px 5px 0 rgba(20, 26, 33, 0.2);
  border: 1px solid ${colorsOptions.greys['grey-30']};

  background: ${colorsOptions.greys.white};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  margin-right: 8px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  padding: 0 0 3px;
  img {
    vertical-align: middle;
  }

  &:hover {
    background: ${colorsOptions.greys['grey-20']};
    color: ${colorsOptions.greys['grey-60']};
    border-color: ${colorsOptions.greys['grey-30']};
    cursor: pointer;
  }
  &:disabled {
    background: none !important;
    opacity: 0.6;
    color: ${colorsOptions.greys['grey-50']};
    border: 1px solid ${colorsOptions.greys['grey-30']};
    cursor: not-allowed;
  }
  @media (min-width: 320px) and (max-width: 1024px) {
    display: none;
  }
`

export const LeftButtonBar = styled.div`
  padding: 38px 34px 38px 38px;
  display: inline-flex;
  gap: 0.5rem;

  margin-top: ${({ show }) => (show ? 0 : '-100px')};
  opacity: ${({ show }) => (show ? 1 : 0)};
  transition: all 0.5s;
  pointer-events: all;

  @media (max-width: 1024px) {
    padding: 5px;
  }
`

const BaseTopRightButton = styled(Button)`
  opacity: ${ifProp('hide', 0, 1)};
  transition: opacity 0.5s;
  color: ${ifProp(
    'active',
    colorsOptions.secondaryColors.orange.normal,
    colorsOptions.greys['grey-100']
  )};
  padding: 9px 25px;
  display: inline-block;
  line-height: 19px;
  box-shadow: 0 1px 5px 0 rgba(20, 26, 33, 0.2);
  border: none;
`

export const ListButton = styled(BaseTopRightButton)`
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
`
export const SplitButton = styled(BaseTopRightButton)`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
`
export const SubmenusLink = styled.ul`
  margin-top: ${({ mobileMode }) => (mobileMode ? -20 : -10)}px;
  width: 40px;
  float: ${({ mobileMode }) => (mobileMode ? 'right' : 'left')};
  position: relative;
  ${({ mobileMode }) => (mobileMode ? 'right: 0px; top: 0px;' : '')}
  li {
    list-style-type: none;

    a {
      ${({ mobileMode }) => (mobileMode ? 'border: none;' : '')}
    }
    a:hover {
      background: ${colorsOptions.greys['grey-20']};
      border-color: ${colorsOptions.greys['grey-30']};
    }
    ul {
      padding: 0;
      margin: 0;
      position: absolute;
      top: 58px;
      right: 5px;
      width: 308px;
      border: 1px solid ${colorsOptions.greys['grey-20']};
      box-shadow: 0 1px 5px 0 rgba(20, 26, 33, 0.2);
      display: block;
      background: ${colorsOptions.greys.white};

      &:after {
        position: absolute;
        right: 9px;
        top: -9px;
        width: 0;
        height: 0;
        content: '';
        border-left: 13px solid transparent;
        border-right: 13px solid transparent;
        border-bottom: 13px solid ${colorsOptions.greys['grey-20']};
      }

      &:before {
        position: absolute;
        right: 9px;
        top: -8px;
        width: 0;
        height: 0;
        content: '';
        border-style: solid;
        border-width: 0 13px 13px 13px;
        border-color: transparent transparent #fff transparent;
        z-index: 3;
      }
      &:hover {
        &:before {
          border: none;
        }
      }
      li {
        list-style-type: none;
        &:last-child {
          border-bottom: none;
        }

        span.nomargin {
          margin: 0;
        }
      }
    }
  }
`
export const Anchor = styled.a`
  border: ${({ mobileMode }) =>
    mobileMode ? 'none' : `1px solid ${colorsOptions.greys['grey-30']}`};
  color: ${colorsOptions.greys['grey-100']};
  width: 39px;
  height: 39px;
  text-align: center;
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]};
  cursor: pointer !important;
  margin: 0 auto;
  letter-spacing: 1px;
  border: 1px solid ${colorsOptions.greys['grey-20']};
  box-shadow: 0 1px 5px 0 rgba(20, 26, 33, 0.2);

  ${({ mobileMode }) =>
    mobileMode
      ? `
    position: absolute;
    right: 5px;
    box-shadow: none;
  `
      : `
    border-radius: 39px;
    background: ${colorsOptions.greys.white};
    display: inline-block;
  `}
`
export const MenuButton = styled.span`
  text-decoration: none;
  padding: 7px 12px;
  color: ${({ disabled }) =>
    disabled
      ? colorsOptions.greys['grey-50']
      : colorsOptions.greys['grey-100']};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]};
  display: block;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer!important')};
  background: ${colorsOptions.greys.white};
  width: 100%;
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  border-bottom: 1px solid ${colorsOptions.greys['grey-20']};
  &:hover {
    background: ${colorsOptions.greys['grey-20']};
  }
  @media (max-width: 767px) {
    padding: 15px 12px;
  }
`
export const Warning = styled.div`
  padding: 10px 10px;
  clear: both;
  overflow: hidden;
  background: ${colorsOptions.greys.white};
  color: ${colorsOptions.greys['grey-100']};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  img {
    float: left;
  }
  span {
    display: inline-block;
    float: left;
    width: 88%;
  }
`

export const LoadingPlanPins = styled.div`
  position: absolute;
  left: calc(50% - 40px);
  top: calc(50% - 40px);
  z-index: 9999;
  padding: 15px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 15px;
`

export const MobileListButtonWrapper = styled.div`
  text-align: center;
  width: ${({ width }) => width}px;
`

export const PinButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const NewPinButtonWrapper = styled.div`
  display: flex;
`

export const AbsoluteCornerWrapper = styled.span`
  position: absolute;
  top: 2px;
  right: 10px;
`

export const TutorialPopUp = styled.div`
  position: relative;
  background-color: ${colorsOptions.secondaryColors.orange.normal};
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  color: ${colorsOptions.greys.white};
  padding: 40px 50px 25px;
  max-height: 40vh;
  max-width: 70vw;
  & > :not(:first-child) {
    margin-top: 0.5em;
  }
`

export const TutorialHeadText = styled.span`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]};
`

export const TutorialSubText = styled.span`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  text-align: center;
`

export const pinIconStyle = css`
  margin-top: 9px;
  margin-left: -7px;
`
